import { useTranslation } from "react-i18next";
import i18next from "src/i18n/config";
import { ExpiredWrapper } from "src/ui/shared/ExpiredWrapper";

import { withMetaDescription } from "@navigation/utils/withMetaDescription";
import { CustomAlert } from "@shared/CustomAlert/CustomAlert";

import { PageContainer } from "../shared/components/PageContainer";

import { useCurrentWorkspaceFeatures } from "./api/helpers";
import { SubscriptionSection } from "./components/SubscriptionSection/SubscriptionSection";
import { useWorkspacePageAccess } from "./hooks/useWorkspacePageAccess";

function WorkspaceSubscriptionPage() {
    const { t } = useTranslation(["pages"]);
    const { workspace, canViewSubscription } = useWorkspacePageAccess();
    const { data: workspaceFeatures = [], isLoading: isWorkspaceFeaturesLoading } = useCurrentWorkspaceFeatures();

    const subscription = workspace?.subscription;

    return (
        <PageContainer fullWidth={false}>
            <ExpiredWrapper>
                {canViewSubscription && subscription ? (
                    <SubscriptionSection
                        subscription={subscription}
                        features={workspaceFeatures}
                        isLoading={isWorkspaceFeaturesLoading}
                    />
                ) : (
                    <CustomAlert severity="info" title={t("pages:workspacePage.restricted.subscription.title")}>
                        {t("pages:workspacePage.restricted.subscription.description")}
                    </CustomAlert>
                )}
            </ExpiredWrapper>
        </PageContainer>
    );
}

export default withMetaDescription(WorkspaceSubscriptionPage, {
    title: i18next.t("pages:workspacePage.pages.subscription.metaTitle"),
    description: i18next.t("pages:workspacePage.pages.subscription.metaDescription"),
});
